import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RealEstatePage = lazy(() => import('../pages/real-estate/page'));
const FinancialEducationPage = lazy(() => import('../pages/financial-education/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/inmobiliaria',
    element: <RealEstatePage />,
  },
  {
    path: '/educacion-financiera',
    element: <FinancialEducationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
